import type {
    MarketResearchDemandAnalysisSearchTrendsByCountryListParams,
    MarketResearchDemandAnalysisSearchTrendsByCountryListData,
} from "@similarweb/pro-api-client";

import { DefaultFetchService } from "app/services/fetchService";

export const SEARCH_TRENDS_BY_COUNTRY_ENDPOINT = "/api/MarketResearch/DemandAnalysis/SearchTrendsByCountry";

export type SearchTrendsByCountryParams = MarketResearchDemandAnalysisSearchTrendsByCountryListParams;
export type SearchTrendsByCountryData = MarketResearchDemandAnalysisSearchTrendsByCountryListData;

/**
 * Fetches search trends data by country for specified keyword lists
 */
export const getSearchTrendsByCountry = (params: SearchTrendsByCountryParams, abortSignal?: AbortSignal) => {
    const fetchService = DefaultFetchService.getInstance();

    /*
     * The reason why we need to use URLSearchParams and concatenate it to the url is that our fetch service joins
     * array parameters with a comma, while we want to add each item to the query string as a separate parameter.
     *
     * For example, if we have the following queryParams object:
     *
     * {
     *     KeywordListIds: ["KeywordGroup;7bf09e55-0bb1-46a8-a093-3746fda03d21", "KeywordGroup;8f7fd194-3ede-4399-a527-ea1bf576b217"]
     * }
     *
     * We want the resulting query string to be:
     *
     * KeywordListIds=KeywordGroup%3B7bf09e55-0bb1-46a8-a093-3746fda03d21&KeywordListIds=KeywordGroup%3B8f7fd194-3ede-4399-a527-ea1bf576b217
     */
    const entries = Object.entries(params).flatMap(([key, value]) => {
        if (value === undefined) {
            return [];
        }
        if (Array.isArray(value)) {
            return value.map((nestedValue: string) => [key, nestedValue]);
        }
        return [[key, value.toString()]];
    });

    const urlSearchParams = new URLSearchParams(entries);
    const url = `${SEARCH_TRENDS_BY_COUNTRY_ENDPOINT}?${urlSearchParams.toString()}`;

    return fetchService.get<SearchTrendsByCountryData>(url, undefined, {
        preventAutoCancellation: true,
        cancellation: abortSignal,
    });
};
